import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Divider, LoadingOverlay } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { useQuery } from '@tanstack/react-query';

import HelpItem from '@/entities/Help/HelpItem';

import { referencesApi } from '@/shared/api/references.ts';
import useAppStore from '@/shared/store/app.store';
import { BottomSheet } from '@/shared/uikit/components/bottomSheet';
import { IconicRow } from '@/shared/uikit/components/rows/IconicRow';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

type HelpProps = {
	isOpen?: boolean;
	close?: () => void;
};

const Help: React.FC<HelpProps> = ({ isOpen, close }) => {
	const navigate = useNavigate();

	const [openedReferenceItem, { close: closeReferenceItem, open: openReferenceItem }] =
		useDisclosure(false);

	const [referenceId, setReferenceId] = useState<number | null>(null);

	const isMobile = useAppStore((state) => state.isMobile);

	const { data: references = [], isLoading } = useQuery({
		queryKey: ['references'],
		queryFn: referencesApi.getAllReferences,
	});

	const handleOpenReference = (id: number) => {
		openReferenceItem();
		setReferenceId(id);
	};

	const handleCloseReference = () => {
		closeReferenceItem();
		setReferenceId(null);
	};

	if (isMobile)
		return (
			<>
				<BottomSheet
					opened={isOpen!}
					onClose={close!}
					title="Проблема"
					withCloseButton={false}
					withBackButton
					isFullScreen
				>
					<Box pos="relative" h="100%">
						<LoadingOverlay
							visible={isLoading}
							zIndex={1000}
							overlayProps={{ radius: 2, blur: 2 }}
						/>
						{references?.map((item, idx) => (
							<Fragment key={item?.id}>
								<IconicRow
									mainText={`${++idx}. ${item?.name}`}
									dimmedText={item?.description}
									onClick={() => handleOpenReference(item.id)}
									clickable
								/>
								<Divider my={8} color="#6670851A" />
							</Fragment>
						))}
					</Box>
				</BottomSheet>

				<HelpItem
					referenceId={referenceId}
					isOpen={openedReferenceItem}
					close={handleCloseReference}
				/>
			</>
		);

	return (
		<LayoutRow
			title={{
				title: { children: 'Проблема', size: 'h4', fw: 800 },
			}}
			type="once"
			style={{ height: 'calc(100vh - 116px)' }}
		>
			<Box pos="relative" h="100%">
				<LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{ radius: 2, blur: 2 }} />
				{references?.map((item, idx) => (
					<Fragment key={item?.id}>
						<IconicRow
							mainText={`${++idx}. ${item?.name}`}
							dimmedText={item?.description}
							onClick={() => navigate(`${item?.id}`)}
							clickable
						/>
						<Divider my={8} color="#6670851A" />
					</Fragment>
				))}
			</Box>
		</LayoutRow>
	);
};

export default Help;
